<!-- <div class="d-flex align-items-center justify-content-between w-100">
    <div class="mr-3"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="18" fill="#F9F9FA"/>
      <rect width="36" height="36" rx="18" stroke="#656D7F"/>
      <path d="M19 23.5H19.5V23V21V20.5H19H17H16.5V21V23V23.5H17H19ZM19 19.5H19.5V19V13V12.5H19H17H16.5V13V19V19.5H17H19ZM8.5 18C8.5 12.7561 12.7561 8.5 18 8.5C23.2439 8.5 27.5 12.7561 27.5 18C27.5 23.2439 23.2439 27.5 18 27.5C12.7561 27.5 8.5 23.2439 8.5 18Z" fill="#CC0000" stroke="#CC0000"/>
      </svg>
      </div>
    <div class="">


      <p class="font-italic mb-0" >{{data.message}}</p>
    </div>
    <div class="ml-3">
      <button class="btn-none" mat-raised-button (click)="snackBar.dismiss()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18" stroke="#828A9B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 6L18 18" stroke="#828A9B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>


      </button>
    </div>
  </div> -->

<div class="disp-flex-AlignCenter w-100">
  <div class="w-20">
    <div class="circle-snack">
      <mat-icon
        aria-hidden="false"
        fontSet="material-icons-outlined"
        aria-label="Example home icon"
        class="dang icons-navs-mat"
        >error
      </mat-icon>
    </div>
  </div>
  <div class="w-70">
    <div class="h-30px disp-flex align-items-center">
      <h1 class="ft-14px mb-0">Error</h1>
      <p class="ml-3 mb-0 mt-1 ft-10px">{{ now | date: 'shortTime' }}</p>
    </div>

    <p class="ft-12px">{{ data.message }}</p>
  </div>
  <div>
    <button class="btn-none" mat-raised-button (click)="snackBar.dismiss()">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18"
          stroke="#828A9B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 6L18 18"
          stroke="#828A9B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</div>
